import * as React from 'react';
import { Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../actions/userActions'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/ShortText';
import Drawer from '@mui/material/Drawer';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {AccountCircle} from '@mui/icons-material';
import Link from '@mui/material/Link';
import { makeStyles } from '@mui/styles';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Avatar from '@mui/material/Avatar';

const useStyles = makeStyles({

  btn_adr: {
    // background: (props) =>
    //   props.color === 'red'
    //     ? 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
    //     : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    background :'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    border: 0,
    borderRadius: 3,
    // boxShadow: (props) =>
    //   props.color === 'red'
    //     ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
    //     : '0 3px 5px 2px rgba(33, 203, 243, .3)',
    boxShadow:'0 3px 5px 2px rgba(33, 203, 243, .3)',
    color: 'white',
    height: 48,
    padding: '0 30px',
    margin: 8,
  },
  btn_adr1: {
    // background: (props) =>
    //   props.color === 'red'
    //     ? 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
    //     : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    background :'linear-gradient(to right, #ec008c, #fc6767);',
    border: 0,
    borderRadius: 3,
    // boxShadow: (props) =>
    //   props.color === 'red'
    //     ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
    //     : '0 3px 5px 2px rgba(33, 203, 243, .3)',
    boxShadow:'0 3px 5px 2px rgba(33, 203, 243, .3)',
    color: 'white',
    height: 48,
    padding: '0 30px',
    margin: 8,
  },
  btn_lunada: {
    // background: (props) =>
    //   props.color === 'red'
    //     ? 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
    //     : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    background :'linear-gradient(to right, #5433ff, #20bdff, #a5fecb);',
    border: 0,
    borderRadius: 50,
    // boxShadow: (props) =>
    //   props.color === 'red'
    //     ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
    //     : '0 3px 5px 2px rgba(33, 203, 243, .3)',
    boxShadow:'0 3px 5px 2px rgba(33, 203, 243, .3)',
    color: 'white',
    // height: 48,
    padding: '5px 5px 5px 5px ',
    margin: 8,
  },
  
  appbar: {
    background: 'none',
  },
  icon: {
    color: '#fff',
    fontSize: '2rem',
  },
  colorText: {
    color: '#5AFF3D',
  },
  container: {
    textAlign: 'center',
  },
  title: {
    color: '#fff',
    fontSize: '4.5rem',
  },
});

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}));

export default function ButtonAppBar() {

  const classes = useStyles();
  const dispatch = useDispatch()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin
  // console.log(userInfo);

  const logoutHandler = () => {
    dispatch(logout())
  }

  const [appBar_bg,setappBar_bg] = React.useState("transparent")
  const [state, setState] = React.useState({
    appBar_color:"transparent",
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [anchorEl, setAnchorEl] = React.useState(null); 
  const [collorAppBar,setCollorAppBar] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isScroll = Boolean(collorAppBar);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);


  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >

     {userInfo ? (
            <>  
             <Link color="inherit" underline="none" href={`/profile`} >
              <MenuItem onClick={handleMenuClose}>{userInfo.data.nickname}</MenuItem>
            </Link>
            <Link color="inherit" underline="none" >
              <MenuItem onClick={logoutHandler}>Logout</MenuItem>
            </Link>
            </>
     ):(
      <Link color="inherit" underline="none" href={`/login`} >
              <MenuItem onClick={handleMenuClose}>Acount</MenuItem>
      </Link>

     )}

    </Menu>
  );

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {['All mail', 'Trash', 'Spam'].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
  let trigger = useScrollTrigger();
  const handleScroll = () => {
    // let scrollTop = event.srcElement.body.scrollTop;
    // setState(state.appBar_color = "inherit")

    // console.log(state.appBar_color)
    // console.log(window.pageYOffset);
     let scrollValue  = window.pageYOffset

    if (scrollValue < 10 ){
        setappBar_bg("transparent");
        }else{
          setappBar_bg("inherit");

        }
  }

  window.addEventListener('scroll', handleScroll);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar className={classes.appbar}   sx={{
          // bgcolor: 'background.paper',
          boxShadow: 5,
          opacity:1,
          borderRadius: 2,
          border:0,
          top: 0,
          // p: 2,
          // minWidth: 300,
        }}
        position="fixed"
        color={appBar_bg}
         >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="secondary"
            aria-label="menu"
            // aria-label="open drawer"
            onClick={toggleDrawer("left", true)}
            sx={{ mr: 2 }}
          >
            <MenuIcon fontSize="large" />
          </IconButton>
          {/* <Paper
            component="form"
            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Me"
              inputProps={{ 'aria-label': 'search google maps' }}
            />
            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
              <SearchIcon />
            </IconButton>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions">
              <DirectionsIcon />
            </IconButton>
          </Paper> */}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            
          </Typography>
          {userInfo ? (
                // <NavDropdown title={userInfo.name} id='username'>
                //   <LinkContainer to='/profile'>
                //     <NavDropdown.Item>Profile</NavDropdown.Item>
                //   </LinkContainer>
                //   <NavDropdown.Item onClick={logoutHandler}>
                //     Logout
                //   </NavDropdown.Item>
                // </NavDropdown>
                
          //  <IconButton className={classes.btn_lunada}
          //   size="large"
          //   aria-label="account of current user"
          //   aria-controls="primary-search-account-menu"
          //   aria-haspopup="true"
          //   color="inherit"
          //   onClick={handleProfileMenuOpen}
          // >
      // <AccountCircle /> 
      //  </IconButton>  

          <Badge color="secondary" overlap="circular" badgeContent=" " variant="dot" onClick={handleProfileMenuOpen} className={classes.btn_lunada}>
            <Avatar alt="Remy Sharp" src={"/images/avatar/"+userInfo.data.pic}  />
          </Badge>
              ) : (
                <>
                <Link color='white' underline="none" href={`/login`} >
                <Button variant="contained" className={classes.btn_adr} >
                  Login
                  </Button>
              </Link>
              <Link sx={{mx:1}} underline="none" href={`/register`} >
                <Button variant="contained" className={classes.btn_adr1} >
                  Signup
                  </Button>
              </Link>
                </>
              )}





        <IconButton aria-label="cart" className={classes.btn_lunada}>
          <StyledBadge badgeContent={4} color="secondary">
            <ShoppingCartIcon fontSize="large"/>
          </StyledBadge>
        </IconButton>
 

        </Toolbar>
      </AppBar>
      {renderMenu}
      <SwipeableDrawer
        anchor="left"
        open={state["left"]}
        onClose={toggleDrawer("left", false)}
      >
        {list("left")}
      </SwipeableDrawer>
    </Box>
    
  );
}